import { useEffect, useState } from "react"
import PaymentForm from "../../../components/Payment-form"
import WithSidebar from "../../../layouts/WithSidebar"
import { ajax } from "../../../scripts/helper"
import utils from "../../../scripts/utils"
import { useSnackbar } from 'notistack'
import { useSearchParams } from "react-router-dom"
import { useLocation } from "react-router-dom"


const SingleLink = () => {
    const { enqueueSnackbar } = useSnackbar()
    const [searchParams, setSearchParams] = useSearchParams()
    const {state} = useLocation()
    

    const [detail, setDetail] = useState()
    const [create, setCreate] = useState(false)
    const [header, setHeader] = useState('Create Link')

    const getTransactiondetail = async (id) => {
        
        const res = await ajax({
            method: 'GET',
            url: utils.urls.linkDetail(id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if (!res) return

        console.log(res, 'dataaaaaaaaaa')

        setDetail(res.data)
        setCreate(false)
    }

    const id = searchParams.get("id")
    const createParams = searchParams.get("create")
    
    useEffect ( () => {
        
        console.log(createParams, 'in chie')
        if(createParams === true) {
            setCreate(true)
            console.log('true mikoni')
        }else{
            setCreate(false)
            console.log('false mikoni')
        }
        if (id) {
            getTransactiondetail(id)
            setHeader('Edit Payment')

        }

        // if(state && state.type === 'calculation'){
        //     console.log(state, 'state from calculation')
        // }
    }, [])

    return(
        <WithSidebar pageTitle={header} breadcrumb={`Dashboard > Payment link > ${header} `}>
            <PaymentForm detail={detail} create={create} />
        </WithSidebar>
    )
}
export default SingleLink